import { fade } from "@material-ui/core/styles/colorManipulator";
const styles = (theme) => ({
  moduleHeader: {
    color: theme.HeaderSelectedText,
    borderBottom: `1px solid ${theme.AppBGColor}`,
    fontWeight: "bold",
    padding: `10px 32px`,
    fontSize: 14,
  },
  mainContent: {
    display: "flex",
    alignItems: "stretch",
    justifyContent:"space-between"
  },
  flexContainer: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    '&>div:nth-child(2)': {
      flexGrow: 1
    },
  },
  moduleContainer: {
    padding: 32,
  },
  moduleMessage: {
    fontSize: theme.textFontSize,
    paddingBottom: 32,
    color: theme.TextColor,
    maxWidth: "80%",
  },
  uploadHeaderMessage: {
    display: "flex",
    flexDirection: "row",
    fontSize: theme.textFontSize,
    paddingBottom: 32,
    color: theme.TextColor,
    maxWidth: "80%",
  },
  terminalText: {
    color: theme.HeaderSelectedText,
    fontSize: theme.textFontSize,
    fontWeight: 600,
    paddingRight: 10,
    minWidth: 64,
    display: "inline-flex",
    lineHeight: "24px",
  },
  terminalContainer: {
    display: "none",
  },
  gridContainer: {
    padding: "32px 0",
    width: "100%",
    maxWidth: 720,
  },
  gridSmallPadding: {
    padding: "12px 0"
  },
  gridHead: {
    padding: "5 0px",
    minHeight: 24,
  },
  gridTitle: {
    color: theme.HeaderSelectedText,
    fontSize: theme.textFontSize,
    fontWeight: 600,
  },
  gridActionIcons: {
    float: "right",
    "& $actionIcon": {
      paddingLeft: 10,
      "&:not(:last-child)": {
        borderRight: `1px solid ${theme.AppBGColor}`,
        paddingRight: 10,
      },
    },
  },
  actionIcon: {
    color: theme.iconColor,
    paddingRight: 5,
    cursor: "pointer",
  },
  action: {
    padding: "10px 0",
  },
  dataGrid: {
    minHeight: 150,
    height: 180,
    maxHeight: 240,
    border: `1px solid ${theme.AppBGColor}`,
    "& .ag-theme-material .ag-body-horizontal-scroll": {
      borderWidth: "0px",
    },
    [`&>.gridTheme-${theme.themeName}>.ag-theme-material.theme-${theme.themeName}`]: {
      height: "100%",
    },
    "& .statusBar": {
      display: "none",
    },
    "& .ag-center-cols-viewport": {
      width: `calc(100% + 18px)`,
    },
  },
  dataGridKpi: {
    height: "100%",
  },
  scenarioGridContainer: { maxWidth: 875 },
  parameterGridContainer: { maxWidth: 1100 },
  proHistoryGridContainer: { maxWidth: "95%", padding: "22px" },
  terminalGrid: { minHeight: "40%", maxHeight: "100%" },
  routeEquipmentMappingGrid: { minHeight: "60%", maxHeight: 600 },
  routeEquipmentMappingGridContainer: { padding: 0 },
  notificationGrid: {
    minHeight: "50%",
    maxHeight: "100%",
    "& .ag-center-cols-viewport": {
      width: `calc(100% + 18px)`,
    },
  },
  trailerInventoryGrid: {
    "& .ag-center-cols-viewport": {
      overflowX: "hidden",
    },
    height: 240,
  },
  terminalGridContainer: {
    maxWidth: "100%",
    padding: 0,
    "& $gridHead": {
      minHeight: 32,
    },
  },
  feederTerminalGridContainer: {
    maxWidth: "68%",
    padding: 0,
    "& $gridHead": {
      minHeight: 32,
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center"
    },
    "& $dataGrid": {
      maxHeight: "65%",
      height: "65%"
    }
  },
  feederTerminalGridHeight: {
    height: 300
  },
  parameterGrid: {
    minHeight: 360,
    maxHeight: 380,
    maxWidth: 1100,
    [`& .gridTheme-${theme.themeName}`]: {
      minHeight: 200,
    },
    "& .statusBar": {
      display: "none",
    },
    "& .ag-center-cols-viewport": {
      width: `calc(100% + 18px)`,
    },
  },
  proHistoryGrid: {
    minHeight: "50%",
    maxHeight: "100%",
    "& .ag-center-cols-viewport": {
      width: `calc(100% + 18px)`,
    },
  },
  restoreIcon: {
    padding: "0 5px",
  },
  actionButton: {
    textTransform: "none",
    minWidth: 170,
    "&$actionDisabled": {
      backgroundColor: theme.customInputBGColor,
      color: theme.TextColor,
      cursor: "not-allowed",
      opacity: 0.8,
    },
  },
  scenarioActionButton: {
    minHeight: 30,
    minWidth: 230,
  },
  downloadTemplateButton: {
    marginLeft: 32,
    minHeight: 20,
    minWidth: 200,
  },
  fileImportActionButton: {
    minHeight: 30,
    minWidth: 230,
  },
  actionIconDisabled: {
    opacity: 0.9,
    pointerEvents: "none",
  },
  dateContainer: {
    paddingTop: 24,
    display: "flex",
  },
  actionEditor: {
    "&>*": {
      marginTop: 0,
    },
  },
  actionDisabled: {
    backgroundColor: theme.customInputBGColor,
    color: theme.TextColor,
    opacity: 0.8
  },
  errorMessageContainer: {
    position: "relative",
    width: "100%",
    height: "100%",
  },
  errorMessage: {
    position: "absolute",
    width: "100%",
    top: "45%",
    textAlign: "center",
    fontSize: theme.textFontSize,
    color: theme.TextColor,
    maxWidth: "80%",
  },

  anchorSubModulePart: {
    borderRight: `1px solid ${theme.AppBGColor}`,
    height: "100%",
  },
  anchorPointModuleContainer: {
    padding: "0px 18px 32px 18px",
    height: `calc(100% - 50px)`,
    boxSizing: "border-box",
  },
  anchorPointContent: {
    borderColor: theme.AppBGColor,
    borderStyle: "solid",
    borderWidth: "1px",
    boxSizing: "border-box",
    height: "100%",
    minHeight: "100%",
    maxHeight: "100%",
    "& .ag-center-cols-viewport": {
      width: `calc(100% + 18px)`,
    },
    "& .statusBar": {
      display: "block",
    },
  },
  anchorPointTerminal: {
    float: "right",
    paddingRight: 16,
  },
  anchorPointHeader: {
    borderBottom: "0px",
  },
  searchContainer: {
    display: "inline-block",
    position: "relative",
    marginRight: 10,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.AppBGColor, 0.25),
    "&:hover": {
      backgroundColor: fade(theme.HeaderBGColor, 0.15),
    },
    marginLeft: 0,
    marginTop: 2,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing.unit,
      width: "auto",
    },
  },
  searchInputRoot: {
    color: "inherit",
    width: "100%",
    height: 32,
    fontSize: 14,
  },
  searchInput: {
    color: theme.iconColor,
    paddingTop: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    paddingLeft: theme.spacing.unit * 10,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: 120,
      "&:focus": {
        width: 200,
      },
    },
  },
  searchIcon: {
    color: theme.iconColor,
    width: theme.spacing.unit * 9,
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  KPIGoalGridContainer: {
    maxWidth: 350,
  },
  reportsIBPlanningGridHeader: {
    padding: "10px 20px",
    borderBottom: "0px",
  },
  reportsIBPlanningGridContainer: {
    padding: "5px 18px 32px 18px",
    height: `calc(100% - 42px)`,
    boxSizing: "border-box",
    clear: "right",
  },
  headerIconStyles: {
    padding: "5px 10px",
    borderLeft: `1px solid ${theme.AppBGColor}`,
    cursor: "pointer",
    color: theme.iconColor,
  },
  clearIcon: {
    paddingRight: "5px",
  },
  iconHidden: {
    visibility: "hidden",
  },
  iconVisible: {
    visibility: "visible",
    color: theme.iconColor,
    cursor: "pointer",
    paddingRight: "5px",
  },
  bold: {
    fontWeight: "bold",
  },
  terminalInfo: {
    padding: "12px 0px",
    margin: 8,
    fontSize: 14,
    color: theme.gridTextColor,
  },
  mainUploadContainer: {
    height: "60%",
  },

  uploadBox: {
    border: `1px solid ${theme.AppBGColor}`,
    minWidth: "80%",
    minHeight: "60%",
    padding: "10px 32px",
  },
  stepperButtonsContainer: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: 5,
  },
  stepperButton: {
    marginLeft: 5,
  },
  mainStepperContainer: {
    root: {
      width: "100%",
    },
    button: {
      margin: 5,
    },
    backButton: {
      marginRight: theme.spacing.unit,
    },
    instructions: {
      marginTop: theme.spacing.unit,
      marginBottom: theme.spacing.unit,
    },
  },

  completed: {
    margin: 5,
  },
  fileUploadButtonContainer: {
    minWidth: "50%",
    minHeight: "20%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },

  fileImportGridContainer: {
    width: "50%",
    margin: "5 auto",
  },

  fileImportErrorContainer: {
    display: "flex",
    justifyContent: "center",
  },

  anchorPointMap: {
    "& .trimblemaps-map .trimblemaps-canvas-container.trimblemaps-interactive":
      {
        cursor: "crosshair",
      },
  },
  anchorPointAutoZoom: {
    float: "right",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    height: "19px",
    [theme.breakpoints.down("md")]: {
      padding: "3px 8px",
    },
  },
  duplicateCustomerSubModule: {
    height: "100%",
    width: "100%",
  },
  mergeIconStyles: {
    padding: "5px 10px",
    borderRight: `1px solid ${theme.AppBGColor}`,
    borderLeft: `1px solid ${theme.AppBGColor}`,
    color: theme.iconColor,
    cursor: "pointer",
  },
  mergeIconNoLeftBorder: {
    borderLeft: "none",
  },
  disableIcon: {
    cursor: "not-allowed",
    opacity: 0.7,
  },
  enableIcon: {
    cursor: "pointer",
  },
  excludeTrap: {
    display: "inline-flex",
  },
  text: {
    color: theme.TextColor ,
  },
  gridHeaderActionContainer : {
    display : "flex",
    alignItems : "center"
  },
  copyLabel : {
    color : theme.TextColor,
    opacity : 0.6,
    fontSize : theme.textFontSize
  },
  copyIcon : {
    paddingLeft : 4,
    color: theme.iconColor,
    paddingRight: 5,
    cursor: "pointer",
  },
  accessibleTerminalGridContainer: {
    maxWidth: "68%",
    padding: 0,
    "& $gridHead": {
      minHeight: 32,
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center"
    },
    "& $dataGrid": {
      maxHeight: "65%",
      height: "65%"
    }
  },
  stepper: {
    backgroundColor: theme.gridBGColor
  },
  stepperLabel: {
    color: theme.TextColor
  },
  optionalStepperText: {
    color: theme.iconColor
  },
  holidayPaperAnchor: {
    position: "absolute",
    width: 380,
    zIndex: 100,
    backgroundColor: theme.ModalBGColor,
  },
  createScenarioButton: {
    maxWidth: 'fit-content'
  },
  actionInProgress: {
    color: theme.white,
  },
  customSearchClass: {
    alignSelf: 'flex-end',
    marginBottom: 4,
    minWidth: 200,
  },
  customSearchWidth200: {
    minWidth: 200,
  },
  searchBoxContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  moduleSelect: {
    width: 140,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 16,
  },
  moduleHeaderContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  moduleHeaderContentLeft: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  circularProgress: {
    color: theme.white,
    marginRight: 8
  },
  unsetMinWidth: {
    minWidth: 'unset'
  }
});

export default styles;
